var map = {
	"./Abcde": 5759,
	"./Abcde.vue": 5759,
	"./Auth/Login": 4971,
	"./Auth/Login.vue": 4971,
	"./Auth/PasswordEmail": 2187,
	"./Auth/PasswordEmail.vue": 2187,
	"./Auth/PasswordReset": 7043,
	"./Auth/PasswordReset.vue": 7043,
	"./Auth/RegistrationComplete": 817,
	"./Auth/RegistrationComplete.vue": 817,
	"./Author": 9623,
	"./Author.vue": 9623,
	"./Authors": 457,
	"./Authors.vue": 457,
	"./BasicPage": 951,
	"./BasicPage.vue": 951,
	"./Category": 2577,
	"./Category.vue": 2577,
	"./Contact": 3793,
	"./Contact.vue": 3793,
	"./EditorialBoard": 9395,
	"./EditorialBoard.vue": 9395,
	"./Error": 872,
	"./Error.vue": 872,
	"./Home": 7528,
	"./Home.vue": 7528,
	"./Post": 649,
	"./Post.vue": 649,
	"./Quizzes": 2104,
	"./Quizzes.vue": 2104,
	"./ResidentsCorner": 1628,
	"./ResidentsCorner.vue": 1628,
	"./Search": 4214,
	"./Search.vue": 4214
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5186;